<template>
  <div class="violationNotice">
    <template v-if="checkAdmin()">
      <el-card shadow="always">
        <el-form
          ref="formInline"
          size="small"
          label-width="110px"
          :model="formInline"
          inline
        >
          <el-form-item prop="title" label="违规公示标题">
            <el-input
              clearable
              v-model.trim="formInline.title"
              placeholder="请输入违规公示标题"
            ></el-input>
          </el-form-item>
          <el-form-item style="margin-left: 30px">
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset" style="margin-left: 8px"
              >重置</el-button
            >
          </el-form-item>
        </el-form>
      </el-card>
      <el-card style="margin-top: 10px" shadow="always">
        <div class="title">
          <el-button size="small" type="primary" @click="openAddViolationNotice"
            >新增</el-button
          >
        </div>
        <el-table border v-loading="loading" :data="data" style="width: 100%">
          <el-table-column label="发布时间" width="220" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.insertDate || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="违规公示标题" width="280" align="center">
            <template slot-scope="{ row }">
              <span>{{ row.title || "--" }}</span>
            </template>
          </el-table-column>
          <el-table-column label="违规公示内容" align="center">
            <template slot-scope="{ row }">
              <el-tooltip class="item" effect="dark" popper-class="tooltip" placement="top">
                <div slot="content" class="tooltip">{{ row.content || '--' }}</div>
                <div class="ellipsis">{{ row.content || "--" }}</div>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            fixed="right"
            align="center"
            label="操作"
          >
            <template slot-scope="{ row }">
              <span class="blue_Box" @click="handleDelete(row.id)">删除</span>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <my-pagination
          :page-info="pageInfo"
          @handleCurrentChange="handleCurrentChange"
          @handleSizeChange="handleSizeChange"
        />
      </el-card>

      <!-- 新增违规公示 -->
      <AddViolationNotice ref="addViolationNoticeRef" />
    </template>
    <template v-else>
      <div
        style="padding-top: 160px"
        v-if="JSON.stringify(noticeData) === '{}'"
      >
        <el-empty description="暂无公示"></el-empty>
      </div>
      <el-card shadow="always" v-else>
        <div class="notice_title">
          <div class="title_lef"></div>
          <div class="title_center">{{ noticeData.title }}</div>
          <div class="title_rig">
            <span class="rig_box" @click="openHistoryNotice"
              >历史公示<span class="el-icon-arrow-right"></span
            ></span>
          </div>
        </div>
        <div class="notice_time">发布时间：{{ noticeData.insertDate }}</div>
        <div class="notice_content">
          <div v-html="noticeData.content"></div>
        </div>
      </el-card>

      <!-- 历史公示 -->
      <HistoryNotice ref="historyNoticeRef" />
    </template>
  </div>
</template>

<script>
import {
  getIllegalPublicityListPage,
  delIllegalPublicity,
} from "@/api/organization/violationNotice.js";
import HistoryNotice from "@/views/organization/components/historyNotice.vue";
import AddViolationNotice from "@/views/organization/components/addViolationNotice.vue";
import myPagination from "@/components/myPagination.vue";
import { clone, processing } from "@/utils/handle.js";
export default {
  name: "ViolationNotice",
  components: {
    myPagination,
    AddViolationNotice,
    HistoryNotice,
  },
  data() {
    return {
      loading: false,
      formInline: {
        title: "",
      },
      data: [],
      pageInfo: {
        page: 1,
        limit: 10,
        total: 0,
      },
      searchData: {},
      noticeData: {},
    };
  },
  created() {
    this.getIllegalPublicityListPage({ page: 1, limit: 10 });
  },
  methods: {
    // 历史公示
    openHistoryNotice() {
      this.$refs.historyNoticeRef.init();
    },
    // 删除
    handleDelete(id) {
      this.$confirm("确认要删除该违规公示吗?", "提示", {
        closeOnClickModal: false,
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          delIllegalPublicity({ id }).then((res) => {
            if (res.code === 0) {
              if (this.pageInfo.total >= this.pageInfo.limit) {
                let sum = this.pageInfo.total % this.pageInfo.limit;
                if (sum === 1) {
                  this.pageInfo.page =
                    Number(this.pageInfo.page) === 1
                      ? 1
                      : Number(this.pageInfo.page) - 1;
                }
              }
              this.refresh();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            }
          });
        })
        .catch(() => {});
    },
    // 新增
    openAddViolationNotice() {
      this.$refs.addViolationNoticeRef.init();
    },
    // 刷新
    refresh() {
      this.getIllegalPublicityListPage(
        Object.assign(this.searchData, {
          page: this.pageInfo.page,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 请求列表
    async getIllegalPublicityListPage(payload) {
      this.loading = true;
      this.pageInfo.page = payload.page;
      this.pageInfo.limit = payload.limit;
      const res = await getIllegalPublicityListPage({ ...payload });
      this.data = res.data?.records || [];
      if (this.data.length > 0) {
        this.noticeData = this.data[0];
      }
      this.pageInfo.total = Number(res.data?.total) || 0;
      this.loading = false;
    },
    // 搜索
    handleSearch() {
      this.searchData = processing(this.formInline);
      this.getIllegalPublicityListPage(
        Object.assign(processing(this.formInline), { page: 1, limit: 10 })
      );
    },
    // 重置
    handleReset() {
      this.searchData = {};
      this.$refs["formInline"].resetFields();
      this.getIllegalPublicityListPage({ page: 1, limit: 10 });
    },
    // 切换页数
    handleCurrentChange(payload) {
      this.getIllegalPublicityListPage(
        Object.assign(clone(this.searchData), {
          page: payload,
          limit: this.pageInfo.limit,
        })
      );
    },
    // 切换每页条数
    handleSizeChange(payload) {
      this.getIllegalPublicityListPage(
        Object.assign(clone(this.searchData), { page: 1, limit: payload })
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.violationNotice {
  .title {
    margin: 0px 0 10px;
  }

  .blue_Box {
    margin: 0 6px;
    color: #2d8cf0;
    cursor: pointer;
  }

  .blue_Box:hover {
    color: #57a3f4;
  }

  .notice_title {
    display: flex;
    .title_lef,
    .title_rig {
      font-size: 14px;
      width: 130px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      .rig_box {
        cursor: pointer;
      }
    }
    .title_center {
      font-size: 28px;
      font-weight: bold;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .notice_time {
    font-size: 16px;
    margin-top: 14px;
    margin-bottom: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .notice_content {
    font-size: 14px;
    ::v-deep img {
      width: 100%;
    }
  }

  ::v-deep .ellipsis {
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 5;
    overflow: hidden;
    word-wrap:break-word;
  }
}
.tooltip {
  width: 800px !important;
}
</style>